
import { Card, CardContent } from '@/components/ui/card';
import { Truck, Wrench, Shield, CreditCard, Users, MapPin } from 'lucide-react';

const services = [
  {
    icon: Truck,
    title: "Vente de camions d'occasion",
    description: "Large sélection de camions Euro 5 et Euro 6, tracteurs routiers et véhicules utilitaires",
    color: "bg-blue-500"
  },
  {
    icon: Wrench,
    title: "Matériel industriel",
    description: "Équipements et matériels industriels pour tous vos besoins professionnels",
    color: "bg-green-500"
  },
  {
    icon: Shield,
    title: "Garantie & Contrôle",
    description: "Tous nos véhicules sont rigoureusement contrôlés et garantis pour votre sécurité",
    color: "bg-purple-500"
  },
  {
    icon: CreditCard,
    title: "Financement",
    description: "Solutions de financement adaptées à vos besoins et reprise de votre ancien véhicule",
    color: "bg-orange-500"
  },
  {
    icon: Users,
    title: "Conseil personnalisé",
    description: "Accompagnement expert pour vous aider à choisir le véhicule adapté à votre activité",
    color: "bg-red-500"
  },
  {
    icon: MapPin,
    title: "Livraison possible",
    description: "Service de livraison dans toute la France pour votre commodité",
    color: "bg-indigo-500"
  }
];

export const ServicesSection = () => {
  return (
    <section className="py-20 bg-gray-50" id="services">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Nos Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Une gamme complète de services pour répondre à tous vos besoins 
            en matière de véhicules industriels
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-0 shadow-lg"
            >
              <CardContent className="p-8 text-center">
                <div className={`w-16 h-16 ${service.color} rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <service.icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Card className="bg-gradient-to-r from-blue-600 to-blue-700 border-0 text-white">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold mb-4">Pourquoi choisir Trucks 52 ?</h3>
              <div className="grid md:grid-cols-3 gap-8 mt-8">
                <div>
                  <div className="text-3xl font-bold text-blue-200 mb-2">15+</div>
                  <p className="text-blue-100">Années d'expérience</p>
                </div>
                <div>
                  <div className="text-3xl font-bold text-blue-200 mb-2">500+</div>
                  <p className="text-blue-100">Véhicules vendus</p>
                </div>
                <div>
                  <div className="text-3xl font-bold text-blue-200 mb-2">100%</div>
                  <p className="text-blue-100">Clients satisfaits</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
